export class ExternalUser {
    firstName: string;
    lastName: string;
    mail: string;
}
